import "primeicons/primeicons.css"; //icons
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { TabMenu } from 'primereact/tabmenu';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import MenuItems from "./MenuItems";
import MenuItems2 from './MenuItems2';
import MenuItems3 from './MenuItems3';
import MenuItems5 from './MenuItems5';
import MenuItems6 from './MenuItems6';
import MenuItems7 from './MenuItems7';
import MenuItems8 from './MenuItems8';
import MenuItems9 from './MenuItems9';
import "./ViewBar.css";
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ViewBar
Description : Tren de navegación del modulo de compañía
Date Autor Modification
================================================================================
03/10/2021 Santiago Coca Rojas Creación – Se implementa la barra de navegación desde cero.
02/11/2021 Cristian Andres pizo – Se agrego al if /Static/ y /Vacation/ para agregarlos a la barra de navegación.
03/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

function ViewBar() {

    /*Propiedades del componente*/
    const [activeIndex, setActiveIndex] = useState("")
    const location = useLocation();
    const [items, setItems] = useState([])
    const [dummy, setDummy] = useState("")
    var r = document.querySelector(':root');
    const items1 = MenuItems()
    const items2 = MenuItems2()
    const items3 = MenuItems3()
    const items5 = MenuItems5()
    const items6 = MenuItems6()
    const items7 = MenuItems7()
    const items8 = MenuItems8()
    const items9 = MenuItems9()
    let history = useHistory();

    useEffect(() => {
        /*Validaciones de ruta del componente*/

        if (location.pathname.match(/CompanyInfo/) || location.pathname.match(/Firms/) ||
            location.pathname.match(/Accountant/) || location.pathname.match(/Payroll/) ||
            location.pathname.match(/CIR/) || location.pathname.match(/ProcessDIAN/) ||
            location.pathname.match(/Jobs/) || location.pathname.match(/Plans/) || location.pathname.match(/Banks/) ||
            location.pathname.match(/DocumentAdmin/)) {

            setItems(items1);
        }

        // if (location.pathname.match(/CreatePerson/) || location.pathname.match(/CreateEmployee/)) {
        //     setItems(items2);
        // }
        if (location.pathname.match(/Overtime/) ||
            location.pathname.match(/Static/) || location.pathname.match(/Vacation/) ||
            location.pathname.match(/Reported/) || location.pathname.match(/Licenses/) ||
            location.pathname.match(/PayrollPaymentProcess/) ||
            location.pathname.match(/SocialSecurity/) ||
            location.pathname.match(/Accounting/) ||
            location.pathname.match(/Severance/) ||
            location.pathname.match(/CIR_Payroll/) ||
            location.pathname.match(/Novelties/) ||
            location.pathname.match(/ElectronicPayroll/) ||
            location.pathname.match(/AdditionalProcess/) ||
            location.pathname.match(/VacationProcess/) ||
            location.pathname.match(/Social_benefitsProcess/)) {
            setItems(items3);
        }
        if (location.pathname.match(/AccountantAccount_Plan/) || location.pathname.match(/AccountantThird/) || location.pathname.match(/AccountantAccountingConf/)) {
            setItems(items1);
        }
        if (location.pathname.match(/Certificate/) || location.pathname.match(/Voucher/) ||
            location.pathname.match(/CIRVoucher/) || location.pathname.match(/PasswordManagement/) || location.pathname.match(/Retefuente/)) {
            setItems(items5);
        }
        if ((location.pathname.match(/Certificate/) || location.pathname.match(/Voucher/) || location.pathname.match(/Retefuente/) ||
            location.pathname.match(/CIRVoucher/) || location.pathname.match(/PasswordManagement/)) && localStorage.getItem("type") === "CLIENT") {
            setItems(items7);
        }
        if (location.pathname.match(/PayOrder/)) {
            setItems(items6);
        }
        if (location.pathname.match(/Employes/) || location.pathname.match(/InitialBalance/) || location.pathname.match(/SalaryChange/)
            || location.pathname.match(/Documents/)) {
            setItems(items8)
        }
        if (location.pathname.match(/OpenPayroll/) || location.pathname.match(/HistoricPayroll/) ||
            location.pathname.match(/PILAHistoricSocialSecurity/) || location.pathname.match(/HistoricAccounting/) ||
            location.pathname.match(/HistoricElectronicPayroll/) || location.pathname.match(/PILASheets/)) {
            setItems(items9)
        }
    }, [dummy, location])

    useEffect(() => {
        if (items.length > 0) {
            const route = items.filter((i) => window.location.pathname.includes(i.path))
            console.log(items)
            console.log(window.location.pathname)
            console.log(route)
            route[0] ? setActiveIndex(route[0].index) : setActiveIndex(activeIndex)
        }
    }, [items])

    const handleTabClick = (event, path) => {
        // Allow right-click to show the default context menu
        if (event.type === "contextmenu") return;

        // Open in new tab if Ctrl+Click (Windows/Linux), Cmd+Click (Mac), or Middle Click
        if (event.ctrlKey || event.metaKey || event.button === 1) {
            window.open(path, "_blank");
        } else {
            event.preventDefault(); // Prevent default navigation
            history.replace(path);
            setActiveIndex(items.findIndex(item => item.path === path)); // Update active tab
        }
    };

    const tabItems = items.map(item => ({
        ...item,
        template: (options) => (
            <a
                href={item.path}
                onClick={(event) => handleTabClick(event, item.path)}
                onContextMenu={(event) => handleTabClick(event, item.path)}
                className={`${options.className} custom-tab`} // Keeps PrimeReact styles
                style={{ all: "unset", cursor: "pointer" }} // Reset <a> styles to avoid breaking UI
            >
                <div className="p-menuitem-link">
                    <span className={item.icon} style={{ marginRight: "8px" }}></span>
                    <span>{item.label}</span>
                </div>
            </a>
        )
    }));

    /*Renderizado del componente*/

    if (location.pathname.match(/Login/) || location.pathname.match(/Register/) ||
        location.pathname.match(/CompleteRegister/) || location.pathname.match(/Logout/) || location.pathname.match(/Users/) ||
        location.pathname.match(/CreatePerson/) || location.pathname.match(/CreateEmployee/) ||
        location.pathname.match(/Users/) || location.pathname.match(/Password_management/) ||
        location.pathname.match(/Support/) || location.pathname.match(/Verification/) || location.pathname.match(/APIDocumentation/) ||
        location.pathname.match(/Home/) || location.pathname.match(/ValidateCertificate/) || location.pathname.match(/TI/)) {
        //localStorage.setItem("barIndex", 0)
        return null;
    }
    else {
        r.style.setProperty('--num-columns', items.length);
        return (
            <div className="divbar surface-100	 inline-flex">
                <TabMenu className='viewbar w-max align-items-center justify-content-center pl-3' model={tabItems} activeIndex={activeIndex} onTabChange={(e) => { setActiveIndex(e.index); setDummy(e.index) }} />
            </div>
        )
    }
}

export default ViewBar